import { axiosInstance as request } from '@api/rest.service'

/**
 * @description /financial-periods
 * @returns {AxiosPromise<any>}
 */

export const GET_FINANCIAL_PERIODS = () => request.get('/financial-periods')
